import { ComboBox, DefaultButton, DirectionalHint, IComboBoxOption, TextField , TooltipHost} from "@fluentui/react";
import React, { FormEvent, useCallback, useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { DateCustom } from "../../lib/DateCustom";
import { useTranslation } from "react-i18next";
import { IActivityRecurring, IAddRecurrentActivity, IPlantillaActividadesXColaborador, IPosplantillaActividadesColaborador, ItipoConcepto } from "../../system/projects/ProjectsSystem";
import { FormUploadHeader, HourMinuteInput, StatusIcon } from "./ImportAct";
import { convertHourToMin, convertMinToHour, FileUpload, formatDate, Iactivities, IconPapers, IListFile, LoadingPage, MyDetailsList } from "./FileUpload";
import { AddIcon, IactError, IActivityRecurringGrid, IAddRows, ICollaborator, IComboBoxInput, IComboBoxOptionGrid, IComboBoxProject, ICompanyPanel, ItipoConceptoGrid, UploadIcon } from "./InterfaceTabla";
import HoursLimitDialog from "../CargarPorFormulario/HoursLimitDialog";
import Custoneader from "./Custoneader";
import { getSessionStorageDataTable, saveOnSessionStorageDataTable } from "../../lib/GlideDataGrid/UtilsGlideGrid";
import DialogRecoveredData from "../../lib/GlideDataGrid/DialogRecoveredData";
import { DateTime } from "luxon";

export interface IactivitiesBody {
  activities:Iactivities[];
  col_id: string;
  exercise_period: string;
  timezone: string;
}

export interface IactivitiesResponse {
  data:Iactivities[];
  error:string;
  type:string;
}

function CargarPorTabla(props: ICompanyPanel) {
  const headers = { idTransaccion:uuidv4(), msgTransaccion:"horas Total Collaborator" }
  const { t, i18n } = useTranslation();
    const [addRows,setAddRows] = useState<IAddRows[]>([]);
    const [actError, setActError] = useState<IactError>({actVali:0,actvErro:0});
    const [desabled, setDesabled] = useState<boolean>(true);
    const [showHoursDialog, setShowHoursDialog] = useState(false);
    const [showRecoveredDataDialog, setShowRecoveredDataDialog] = useState(false);

    const [allCollaborators, setAllCollaborators] = useState<IComboBoxOption[]>([]);
    const [filteredCollaborators, setFilteredCollaborators] = useState<IComboBoxOption[]>([]);
    const [collaboratorValue, setCollaboratorValue] = useState<string>('');
    const [collaboratorId, setCollaboratorId] = useState<string>('');
    const [listFile, setListFile] = useState<IListFile[]>([]);

    const [periodo,setPeriod] = useState<Date>(DateCustom.getFirstDayOfThisMonth())
    const [horasTotal, setHorasTotal] = useState<number>(0);
    const [horasExcedidas, setHorasExcedidas] = useState<number>(0);
    const [desableAddRow, setDesableAddRow] = useState<boolean>(false);
    const previousValuesMap = useRef<Map<string, number>>(new Map());

    const [mountBlock, setMountBlock] = useState<{[key: number]: number[]}>({});
    const [horasTotalCollaborator,setHorasTotalCollaborator] = useState<number>(0);
    const actividadRecurrentenbasic:IActivityRecurringGrid  = {
      ar_id:"",ar_nombre_descripcion:"",ar_proy_id:"",value:"",
      label:"",ar_activo:1,ar_date_created:new Date(),ar_date_modified:new Date(),ar_eliminado:0,
      ar_nombre_act:"",ar_user_created:"web",ar_user_modified:"web",ar_empresa_id:0,ar_pais_id:0
    };

    const [listtipoConcept,setListtipoConcept] = useState<ItipoConceptoGrid[]>([]);
    const [filterTipoConsept, setFilterTipoConsept] = useState<ItipoConceptoGrid[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [listCompanies, setListCompanies] = useState<any[]>([]);
    const [listProjects, setListProjects] = useState<IComboBoxProject[]>([]);
    const [listServices, setListServices] = useState<IComboBoxProject[]>([]);
    const [listAllProjects, setListAllProjects] = useState<IComboBoxProject[]>([]);
    const [lisActRecurrente, setLisActRecurrente] = useState<IActivityRecurringGrid[]>([]);

    const [selectedRows, setSelectedRows] = useState<IAddRows[]>([]);
    const [countAddRows, setCountAddRows] = useState<number>(1);

    useEffect(() => {
      // Calcular el total de horas que se intenta registrar en el mes
      const totalHorasCargadas = addRows.reduce((acc, row) => acc + convertHourToMin(row.horasCarg, row.minuteCarg), 0);

      // Validar si excede el límite de horas
      if (totalHorasCargadas > horasTotalCollaborator) {
        props.courier.messageWarning(
          `Has superado las horas establecidas para este mes.
          Puedes modificar las horas antes de registrar tus actividades.
          [Recuerda que solo se permite un máximo de 3 horas extras por día, ${horasExcedidas.toString().split(":")[0]} horas extras al mes.]`
        );
      } else {
        if (addRows.length > 0 && totalHorasCargadas > 0) {
          props.courier.messageWarning('')
        }
      }
    }, [addRows, horasTotalCollaborator])

    const getAllPeriodBlocks = async () => {
      const periodBlocks = await props.system.getAllPeriodsBlocked();
      const newMountBlocks = periodBlocks
        .map((data) => ({
          year: data.getFrom().year,
          month: data.getFrom().month,
        }))
        .reduce((acc, { year, month }) => {
          if (!acc[year]) acc[year] = [];
          acc[year].push(month);
          return acc;
        }, {} as { [key: number]: number[] });
      setMountBlock(newMountBlocks);
    };

    const handleSelectCollaborator =async (option: IComboBoxOption | undefined) => {
      props.changeBlockUI(true);
      cleanActiveProject();
      setCollaboratorValue(option?.text || "");
      if (option?.key !== undefined) {
        const data = String(option.key);
        setCollaboratorId(data);
        const exercise_period = formatDate(periodo);
        await  getHorasTal(data,exercise_period);
      }
      props.changeBlockUI(false);
    };

    const getIdfolder= async (id:string)=>{
      const respuesta = await props.system.getActivitySystem().IdFolder(id);
      return respuesta;
    }

    const handleFilterCollaborator = (text: string) => {
      setCollaboratorValue(text);
      const data = allCollaborators.filter(g => g.text.toLowerCase().includes(text.toLowerCase()));
      setFilteredCollaborators(data);
    };

    const formatCollaboratorData = (data: ICollaborator[]) => {
      const result: IComboBoxOption[] = data.map(col => ({
        key: col.id,
        text: `${col.name} ${col.lastName}`,
        active: col.active,
        email: col.email
      }));
      if (!result) return;
      setAllCollaborators(result);
      setFilteredCollaborators(result);
    };

    const fetchCollaborators = async () => {
      try {
        const data = await props.system.getActivitySystem().getCommonContext();
        formatCollaboratorData(data.colaboradores as ICollaborator[]);
      } catch (error) {
        console.error('Error fetching collaborators:', error);
      }
    };

    const fetchProjects = async (userData:string,periodo:string,tipoConcept:string | number |undefined) => {
      try {
        const data = await props.system.getAllProjectsByCollaboratorCargarFormulario(userData,periodo,tipoConcept);
        // const transformsci =  data.map(v=>({ key:v.getId(),text:v.getName(), code:v.getCode(), pro_inicio:  v.getStart(), pro_fin: v.getEnd() }));
        const transformsci: IComboBoxProject[] =  data.map(v=>({ value:v.getId(), label:v.getName(), code:v.getCode(), pro_inicio:  v.getStart(), pro_fin: v.getEnd() }));
        return transformsci
      } catch (error) {
        console.error('Error fetching projects:', error);
      }
    };

    const getDataLocalStorage = () => {
      const recoveredData = getSessionStorageDataTable() || [];
      setShowRecoveredDataDialog(recoveredData?.length > 0 ? true : false);
    }

    const getLisTipoConcept = async ()=>{
       try{
        const data = await props.system.getProjectSystem().gettipoConsepto(headers.idTransaccion);

        const dataFormat: ItipoConceptoGrid[] = data.map(item => ({
          value: item.key,
          label: item.text,
          codigo: item.codigo,
        }));

        setListtipoConcept(dataFormat);
        setFilterTipoConsept(dataFormat);
       }catch(error){
        console.log('error fetching tipo concept', error);
       }
    };

    const getCompaniesAndProjects = async () => {
      try {
        const data = await props.system.getCompanySystem().getList();
        const options: IComboBoxOptionGrid[] = data.map((country) => ({
          value: country.getId(),
          label: country.getName(),
        }));
        setListCompanies(options);

        const exercise_period = formatDate(periodo);
        const dataProjects = await fetchProjects(collaboratorId,exercise_period,1);
        const dataProjectsServices = await fetchProjects(collaboratorId,exercise_period,2);
        const allProjects = [
            ...(dataProjects ?? []),
            ...(dataProjectsServices ?? [])
        ]
        setListProjects(dataProjects || []);
        setListServices(dataProjectsServices || []);
        setListAllProjects(allProjects || []);

      } catch (error) {
        console.log('error fetching list empresas y proyectos', error);
      }
    }

    const validateRow = (row: IAddRows, id?: string) => {
      let descripcionError = "";
      const nombreActValido = /^[^\s]/.test(row.nombreAct) && !/\s{2,}/.test(row.nombreAct);
      const regex = /^(?:\d{1,3}:)?(\d{1,2}|undefined)?$/;
      const segundoRegex = /^:\d{1,2}$/;
      const valorMin =  convertHourToMin(row.horasCarg, row.minuteCarg)
      const regexUndefine = /:undefined|undefined/;
      if (
        !row.comapaniesSelect?.length &&
        !row.tipoConcepto?.text &&
        !row.nombrePro?.text &&
        !row.nombreAct &&
        (row.horasCarg == '00:00' || !row.horasCarg) &&
        (!row.minuteCarg || row.minuteCarg === '00')
      ) {
        return { ...row , descripcionError: 'nueva fila', valida: 2 };
      } else {
        if (
          (!row.nombreAct && !row.horasCarg) ||
          (!row.nombrePro?.text && !row.horasCarg) ||
          !row.tipoConcepto?.text ||
          !row.comapaniesSelect?.length
        ) {
          descripcionError = t(
            "Los campos obligatorios (*) no pueden ser vacíos"
          );
        } else {
          if (!nombreActValido && (!row.nombrePro || !row.nombrePro.text)) {
            descripcionError = t(
              "Los campos obligatorios (*) no pueden ser vacíos"
            );
          } else if (!nombreActValido) {
            descripcionError = t("El nombre de la actividad no puede ser vacío.");
          } else if (row.nombreAct?.length <= 3) {
            descripcionError = t("El nombre es muy corto.");
          } else if (!row.nombrePro.text) {
            descripcionError = t("Nombre de proyecto vacío.");
          }
          if (!row.horasCarg && !row.minuteCarg) {
            descripcionError = t("Horas está vacío.");
          } else if (valorMin === 0) {
            if (!row.nombreAct || row.nombreAct === "") {
              descripcionError = t(
                "Los campos obligatorios (*) no pueden ser vacíos"
              );
            } else if (valorMin === 0 && !row.nombrePro.text) {
              descripcionError = t(
                "Los campos obligatorios (*) no pueden ser vacíos"
              );
            } else {
              descripcionError = t("Hora no valida");
            }
          } else if (
            !regex.test(row.horasCarg) &&
            !segundoRegex.test(row.horasCarg) &&
            regexUndefine.test(row.horasCarg)
          ) {
            descripcionError = t("Horas solo admite números.");
          }
        }
      }

      const minIngresados =
        convertHourToMin(row.horasCarg, row.minuteCarg) *
        (row.comapaniesSelect?.length || 1);

      const prevValue = previousValuesMap.current.get(id || "") || 0;
      setHorasTotal(
        (prevHorasTotal) => prevHorasTotal + prevValue - minIngresados
      );
      previousValuesMap.current.set(id || "", minIngresados);

      return { ...row, descripcionError, valida: descripcionError ? 0 : 1 };
    };

    const validateRowById = (rows: IAddRows[], id: string) => {

      const updatedRows = rows.map(row => row.id === id ? validateRow(row,row.id) : row);
      setAddRows(updatedRows);
      saveOnSessionStorageDataTable(updatedRows);
      HandlerNumError(updatedRows);
    };

    const HandlerAddRows = (numRows: number = 1) => {
      // 1. Crear un array temporal para almacenar las nuevas filas
      const newRows: IAddRows[] = [];

      // 2. Iterar 'numRows' veces para crear la cantidad de filas especificadas
      for (let i = 0; i < numRows; i++) {
        const newdata: IAddRows = {
          id: uuidv4(), // Asegúrate de que uuidv4 se llame en cada iteración para tener IDs únicos
          nombrePro: { key: "", text: "" },
          nombreAct: "",
          horasCarg: "",
          minuteCarg: "",
          file: "",
          valida: 2,
          descripcionError: t("nueva fila"),
          actividadRecurrente: "si",
          lisActRecurrente: [],
          actividadRecurrenteSelect: actividadRecurrentenbasic,
          comapaniesSelect: [],
          tipoConcepto: { key: "", text: "", codigo: "" },
          listaProyectos: [],
          listaEmpresa: [],
          filterListProyectos: [],
          descripcion: "",
          paisEmpresa: { key: "", text: "" },
          nombreEmp: { key: "", text: "" },
          options: 0,
          files: [],
        };
        newRows.push(newdata);
      }

      // 3. Agregar las nuevas filas al estado existente
      setAddRows([...addRows, ...newRows]);
    };

    const HandlercleanEverything = () => {
      const selectedRowIds = new Set(selectedRows.map((row) => row.id));
      const selectRowHours = selectedRows.reduce((acc, row) => {
        const timeString = row.horasCarg && row.horasCarg.includes(':') ? row.horasCarg : `${row.horasCarg}:${row.minuteCarg}`;
        const [hours, minutes] = timeString.split(':').map(Number);
        return acc + (hours * 60 + minutes);
      }, 0);

      const rowsToKeep = addRows.filter((row) => !selectedRowIds.has(row.id));
      const finalRows = rowsToKeep.map(r => validateRow(r, r.id));
      setAddRows(finalRows);
      saveOnSessionStorageDataTable(finalRows);
      HandlerNumError(finalRows);
      setHorasTotal(horasTotal + (selectRowHours || 0));
      setLoading(false);
      setSelectedRows([]);
    };

    const HandlerDeleteRows = (id:string)=>{
      const result = addRows.filter(r=>r.id !== id);
      setAddRows(result);
      HandlerNumError(result);
      ///horas 
      const prevValue = previousValuesMap.current.get(id) || 0;
      setHorasTotal(horasTotal + prevValue);
      previousValuesMap.current.delete(id);

      // files id compuesto
      setListFile(prev => prev.filter(item => !item.id.startsWith(id + '@'))); // Ejemplo de id compuesto: "id@uuid"
    }

    const HandlerNombreAct = (option:IActivityRecurringGrid, id: string, newValue: string | undefined,)  => {

      const projectDetail = addRows.filter((item) => item.id === id);
      let objectOption: IActivityRecurringGrid;

      if (option?.ar_proy_id){
        objectOption = option;
      } else {
        objectOption = {
          ar_activo: 1,
          ar_date_created: new Date(),
          ar_date_modified: new Date(),
          ar_eliminado: 0,
          ar_empresa_id: parseInt(projectDetail[0].nombreEmp.key.toString()),
          ar_id: "",
          ar_nombre_act: newValue || "",
          ar_nombre_descripcion: "",
          ar_pais_id: 1,
          ar_proy_id: projectDetail[0].nombrePro.key.toString(),
          ar_user_created: "web",
          ar_user_modified: "web",
          label: newValue || "",
          value: ""
        };
      }

      const valuess = newValue || "";
      const updatedRows = addRows.map(r => r.id === id ? { ...r, nombreAct: valuess, actividadRecurrenteSelect: objectOption } : r);
      validateRowById(updatedRows,id);
    };

    const HandlerNombreActNuevo = (id:string,text:string)=>{
      const updatedRows = addRows.map(r => r.id === id ? { ...r, nombreAct:text} : r);
        validateRowById(updatedRows, id);
    }

    const HandlerContHoras = (id: string, newValue: string | undefined, type: 'hour' | 'minute') => {
      const updatedRows = addRows.map(row => {
        if (row.id === id) {
          const [currentHour, currentMinute] = (row.horasCarg || "00:00").split(':');
          const newHour = type === 'hour' ? newValue || '00' : currentHour;
          const newMinute = type === 'minute' ? newValue || '' : currentMinute;
          return { ...row, horasCarg: `${newHour}:${newMinute}` };
        }
        return row;
      });
      validateRowById(updatedRows, id);
    };

    const HandlerContOnlyMinute = (newValue: IComboBoxOptionGrid, id: string) => {

      const updatedRows = addRows.map(row => {
        if (row.id === id) {
          const [currentHour, currentMinute] = (row.horasCarg || "00:00").split(':');
          const newMinute = newValue?.value.toString() || "00";
          return { ...row, horasCarg: `${currentHour}:${newMinute}`, minuteCarg: newMinute};
        }
        return row;
      });
      validateRowById(updatedRows, id);
    };

    const onselectProject = async(option: IComboBoxProject | undefined, id: string, inputText: string | undefined) => {
      const updatedRows = addRows.map((r) =>
        r.id === id
          ? {
              ...r,
              nombrePro: { key: option?.value || "", text: inputText || option?.label || "" },
              // nombreAct: "",
              pro_inicio: option?.pro_inicio,
              pro_fin: option?.pro_fin,
            }
          : r
      );
      validateRowById(updatedRows, id);
      setLoading(true);
      const getListActvityRecurring = await props.system.getLisActivityRecurring(String(option?.value),id);

      const getListActvityRecurringFormat: IActivityRecurringGrid[] = getListActvityRecurring.map(item => {
        const { key, text, ...rest } = item;
        return {
            ...rest,
            value: key,
            label: text,
        };
      })

      if(getListActvityRecurring){
        const updatedRowss = updatedRows.map(r => r.id === id ? { ...r,lisActRecurrente:getListActvityRecurringFormat} : r);
        setLisActRecurrente(getListActvityRecurringFormat);
        validateRowById(updatedRowss, id);
      }
      setLoading(false);
    };

    const ProjectFilterChange = (
      text: string,
      id: string,
      listaProyect: IComboBoxOptionGrid[]
    ) => {
      const updatedRows = addRows.map((r) =>
        r.id === id
          ? {
              ...r,
              nombrePro: { ...r.nombrePro, text: text || "" },
              filterListProyectos: listaProyect.filter((g) =>
                g.label.toLowerCase().includes(text.toLowerCase())
              ),
            }
          : r
      );
      validateRowById(updatedRows, id);
    };

    const onselecTipoConcept = async(option: any, id: string) => {
      const updatedRows = addRows.map((r) =>
        r.id === id
          ? {
              ...r,
              tipoConcepto: {
                key: option?.value,
                text: option?.label,
                codigo: option?.codigo,
              },
              nombrePro: { key: "", text: "" },
              // listaProyectos: [],
              // filterListProyectos: [],
              // nombreAct: "",
              // actividadRecurrente: "",
              // actividadRecurrenteSelect: undefined,
              // lisActRecurrente: [],
            }
          : r
      );
      validateRowById(updatedRows, id);
      if (option) {
        setLoading(true);
        const data = option?.value === "1" ? listProjects : listServices;
        if(data){
          const listProyectFiltrado = updatedRows.map((r) =>
            r.id === id
              ? { ...r, listaProyectos: data }
              : r
          );
          validateRowById(listProyectFiltrado, id);
        }
        setLoading(false);
      }
    };

    const onselectCountry = async(option:IComboBoxOption  | undefined, id: string) => {
      console.log("onselectCountry");
    };

    const onselectCompany = async(options:any, id: string) => {

      const updatedRows = addRows.map((r) =>
        r.id === id
          ? {
              ...r,
              nombreEmp: { key: options[0]?.value, text: options[0]?.label },
              comapaniesSelect: options,
              // nombrePro: { key: "", text: "" },
              // tipoConcepto: { key: "", text: "", codigo:"" },
              // listaProyectos: [],
              // filterListProyectos: [],
              // nombreAct: "",
            }
          : r
      );
      validateRowById(updatedRows, id);
    };

    const tipoConceptFilterChange = (text: string, id: string) => {
      const updatedRows = addRows.map(r => r.id === id ? { ...r, tipoConcepto: { ...r.tipoConcepto, text: text || "" } } : r);
      const data = listtipoConcept.filter(g => g.label.toLowerCase().includes(text.toLowerCase()));
      setFilterTipoConsept(data);
      validateRowById(updatedRows, id);
    };

    const handlerDescripcion = (data: string | undefined, id:string) => {
      const updatedRows = addRows.map(r => r.id === id? { ...r, descripcion:data || ""}:r);
      validateRowById(updatedRows,id);
    }

    const cleanHour = (value: string) => {
      if (!value) return "00:00";
      return value.replace(/^="?/, "").replace(/"$/, "");
    };

    const HandlerPasteData = (data: any[][]) =>{
      setLoading(true);
      let updatedRows = [...addRows];
      for (const row of data) {
        const idRowData = row.find(item => "id" in item);
        updatedRows = addRows.map((rowCurrent) => {
          if (rowCurrent.id === idRowData.id) {
            for (const field of row) {
              const [key, value] = Object.entries(field)[0];

                if (key !== "id" && key in rowCurrent) {
                switch (key) {
                  case "nombreEmp":
                    const comapanyFormatArr = String(value).split(", ");
                    const companySet = new Set(comapanyFormatArr);

                    const companiesFilter = listCompanies.filter((commpany) => {
                      return companySet.has(commpany.label);
                    });

                    rowCurrent["comapaniesSelect"] =
                      companiesFilter as IComboBoxOptionGrid[];

                    break;

                  case "tipoConcepto":
                    const tipoConceptoDetail = listtipoConcept.find(
                      (typeConcept) =>
                        typeConcept.label
                          .toLowerCase()
                          .includes(String(value).toLowerCase())
                    );

                    if (tipoConceptoDetail) {
                      const { value, label, codigo } = tipoConceptoDetail;

                      const dataProjects =
                        value === "1" ? listProjects : listServices;

                      rowCurrent["listaProyectos"] = dataProjects;
                      rowCurrent[key] = {
                        key: value,
                        text: label,
                        codigo: codigo || "",
                      };
                    } else {
                      console.warn(
                        `No se encontró un concepto que coincida con el valor: ${value}`
                      );
                    }
                    break;

                  case "nombrePro":
                    const projectDetail = listAllProjects.find((project) =>
                      project.label
                        .toLocaleLowerCase()
                        .includes(String(value).toLocaleLowerCase())
                    );

                    if (projectDetail) {
                      const { value: p, label } = projectDetail;
                      const listActvityRecurringFormat = updatedRows.find(row => row.nombrePro.text === label);
                      rowCurrent["lisActRecurrente"] = listActvityRecurringFormat?.lisActRecurrente || [];
                      rowCurrent[key] = {
                        key: p,
                        text: label,
                      };
                    }

                    break;

                  case "nombreAct":
                    let activityRecurrentBasic: IActivityRecurringGrid = {
                      ar_activo: 1,
                      ar_date_created: new Date(),
                      ar_date_modified: new Date(),
                      ar_eliminado: 0,
                      ar_empresa_id: parseInt(
                        rowCurrent.nombreEmp.key.toString()
                      ),
                      ar_id: "",
                      ar_nombre_act: String(value) || "",
                      ar_nombre_descripcion: "",
                      ar_pais_id: 1,
                      ar_proy_id: rowCurrent.nombrePro.key.toString(),
                      ar_user_created: "web",
                      ar_user_modified: "web",
                      label: String(value) || "",
                      value: "",
                    };

                    rowCurrent[key] = String(value);
                    rowCurrent["actividadRecurrenteSelect"] =
                      activityRecurrentBasic;

                    break;

                  case "horasCarg":
                    rowCurrent["horasCarg"] = String(value);
                    break;
                  case "minuteCarg":
                    let valueFinal = String(value) === '0' ? '00' : String(value); 
                    rowCurrent["minuteCarg"] = valueFinal;
                    break;
                  default:
                    rowCurrent[key] = String(value);
                    break;
                }
              }
            }
            return rowCurrent;
          }
          return rowCurrent;
        });
      }

      const finalRows = updatedRows.map(r => validateRow(r, r.id));
      setAddRows(finalRows);
      setSelectedRows(finalRows);
      saveOnSessionStorageDataTable(finalRows);
      HandlerNumError(finalRows);
      setLoading(false);
    };

    const HandlerDeleteData = async (data: any[][]) =>{
      setLoading(true);
      let updatedRows = [...addRows];
      for (const row of data) {
        const idRowData = row.find(item => "id" in item);

        updatedRows = addRows.map((rowCurrent) => {
          if (rowCurrent.id === idRowData.id) {
            for (const field of row) {
              const [key, value] = Object.entries(field)[0];

              if (key !== "id" && key in rowCurrent) {
                switch (key) {
                  case "nombreEmp":
                    rowCurrent[key] = { key: "", text: "" };
                    rowCurrent['comapaniesSelect'] = [] as IComboBoxOptionGrid[];

                    break;

                  case "tipoConcepto":

                    rowCurrent[key] = {
                      key: "",
                      text: "",
                      codigo: ""
                    };

                    break;

                  case "nombrePro":

                    rowCurrent[key] = {
                      key: "",
                      text: ""
                    };

                    break;

                  case "nombreAct":

                    let activityRecurrentBasic: IActivityRecurringGrid = {
                      ar_activo: 1,
                      ar_date_created: new Date(),
                      ar_date_modified: new Date(),
                      ar_eliminado: 0,
                      ar_empresa_id: parseInt(rowCurrent.nombreEmp.key.toString()),
                      ar_id: "",
                      ar_nombre_act: "",
                      ar_nombre_descripcion: "",
                      ar_pais_id: 1,
                      ar_proy_id: rowCurrent.nombrePro.key.toString(),
                      ar_user_created: "web",
                      ar_user_modified: "web",
                      label: "",
                      value: ""
                    };

                    rowCurrent[key] = "";
                    rowCurrent['actividadRecurrenteSelect'] = activityRecurrentBasic;

                    break;

                  case "horasCarg": {

                    rowCurrent['horasCarg'] = "00:00";

                    break;
                  }
                  default:
                    rowCurrent[key] = "";

                    break;
                }

              }
            }
            return rowCurrent;
          }
          return rowCurrent;
        });
      }

      const finalRows = updatedRows.map(r => validateRow(r, r.id));
      setAddRows(finalRows);
      saveOnSessionStorageDataTable(finalRows);
      HandlerNumError(finalRows);
      setLoading(false);
    };

    const updateActivityNameAndDescription = (
      id: string,
      newNombreAct: string,
      newDescripcion: string
    ) => {
      setAddRows(prev => {
        const updatedRows = prev.map((row) => {
          if (row.id === id) {
            return {
              ...row,
              nombreAct: newNombreAct,
              descripcion: newDescripcion,
            };
          }
          return row;
        });
        // Validar la fila actualizada en tiempo real
        validateRowById(updatedRows, id);
        return updatedRows;
      });
    };

    const HandlerPeriodo = async (date:Date)=>{
      props.changeBlockUI(true);
      cleanActiveProject()
      setPeriod(date);
      const exercise_period = formatDate(date);
      await getHorasTal(collaboratorId,exercise_period);
      props.changeBlockUI(false);
    }

    const cleanActiveProject = ()=>{
     setHorasTotal(0);
     setAddRows([]);
     setDesabled(true);
     HandlerNumError([]);
    }

    const cleanActiveProjectsLaterSave = () => {
      setHorasTotal(0);
      setAddRows([]);
      setDesabled(true);
      HandlerNumError([]);
    }

    const handleFileSelect = async (file: File,project:IComboBoxOption,id:string) => {
       const idfolder:any = await  getIdfolder(String(project?.key));
      const idFile =await  props.system.documentTypeOtherId();
      if(idFile && idfolder){
        const data:IListFile ={ 
          path:file,
          id,
          file:{
        cmd_proid: project.key,
        cmd_cant_archivos: 1,
        cmd_cant_bytes_total: file.size,
        cmd_tipo: "proyecto",
        cargaDocumentosItems: [
          {
            cmdi_cant_bytes: file.size,
            cmdi_doc_uuid: "0",
            cmdi_nombre_archivo: file.name,
            cmdi_content_type: file.type,
            doctId: idFile,
            tipo: "proyecto"
          }
        ],
        folderId: String(idfolder?.pca_id)
        }
      }

      const updatedListFile = listFile.map(item => 
        item.id === data.id ? data : item
      );
      
      if (!listFile.some(item => item.id === data.id)) {
        updatedListFile.push(data);
      }
      
      setListFile(updatedListFile);
      }
    };

    const formatPeriodToYYYYMMDD = (datePeriod: Date) => {
      const fecha = datePeriod instanceof Date ? datePeriod : new Date(datePeriod);
      return fecha.toISOString().split("T")[0];
    }

    const saveFile = async () => {
      const idFile = await props.system.documentTypeOtherId();
      // Actualizar los archivos en la lista del doctId
      const updatedListFile = listFile.map(item => {
        return {
          ...item,
          file: {
            ...item.file,
            cargaDocumentosItems: item.file.cargaDocumentosItems.map(cargaItem => ({
              ...cargaItem,
              doctId: idFile
            }))
          }
        }
      });

      for (const item of updatedListFile) {
        try {
           await props.system.getActivitySystem().UploadfileForm(item.file, item.path, formatPeriodToYYYYMMDD(periodo));
        } catch (error) {
          console.error('Error uploading file:', error);
        }
      }
    };

    const HandlerNumError = (validados: IAddRows[]) => {
      const actVali = validados.filter((g) => g.valida === 1);
      const actvErro = validados.filter((g) => g.valida === 0);
      const actvEarring = validados.filter((g) => g.valida === 2);
      const existDescriptionError = validados.some(
        (g) => g.descripcionError !== "nueva fila" && g.descripcionError !== ""
      );

      setActError({ actVali: actVali.length, actvErro: actvErro.length });

      if (
        actvErro.length === 0 &&
        validados.length !== 0 &&
        !existDescriptionError
      ) {
        setDesabled(false);
      } else {
        setDesabled(true);
      }
    };

    const onsubmit = async (ev: FormEvent<HTMLFormElement>) => {
      ev.preventDefault();

      // Calcular el total de horas que se intenta registrar en el mes
      const totalHorasCargadas = addRows.reduce((acc, row) => acc + convertHourToMin(row.horasCarg, row.minuteCarg), 0);

      // Validar si excede el límite de horas
      if (totalHorasCargadas > horasTotalCollaborator) {
        setShowHoursDialog(true);
        return;
      }

      // Si no se supera el límite de horas, proceder con la carga
      handleConfirmHoursDialog();
      saveOnSessionStorageDataTable([]);
    }

    const handleConfirmHoursDialog = async () => {
      props.courier.messageWarning("");
      setShowHoursDialog(false);
      props.changeBlockUI(true);
      if (addRows) {

        const filteredRows = addRows.filter((row) => row.valida === 1);

        const tranForm = filteredRows.flatMap((row) => {
          const numer = convertHourToMin(row.horasCarg as any, row.minuteCarg as any);

          if (
            Array.isArray(row.comapaniesSelect) &&
            row.comapaniesSelect?.length > 0
          ) {
            return row.comapaniesSelect?.map((comp) => ({
              impai_nombre: row.nombreAct,
              impai_cantidad_horas: convertMinToHour(numer),
              impai_codigo_proyecto: row.nombrePro.code,
              impai_proid: row.nombrePro.key,
              impai_con_error: false,
              impai_descripcion_error: row.descripcionError,
              impai_descripcion: row.descripcion,
              impai_codigo_empresa: comp.value,
            }));
          }

          return [
            {
              impai_nombre: row.nombreAct,
              impai_cantidad_horas: convertMinToHour(numer),
              impai_codigo_proyecto: row.nombrePro.code,
              impai_proid: row.nombrePro.key,
              impai_con_error: false,
              impai_descripcion_error: row.descripcionError,
              impai_descripcion: row.descripcion,
              impai_codigo_empresa: row.nombreEmp.key,
            },
          ];
        });

        const body: IactivitiesBody = {
          activities: tranForm,
          col_id: collaboratorId,
          exercise_period: DateCustom.formatDateYYYYMM(periodo),
          timezone: "America/Lima",
        };

        setDesabled(true);
        const numProjetct = filteredRows.length;

        try {
          const importForm = await props.system.getActivitySystem().saveActivity(headers, body);
          await saveFile();
          cleanActiveProjectsLaterSave();
          postPlantillaActividadesXColaborador();
          getHorasTal(collaboratorId, DateCustom.formatDateYYYYMM(periodo));
          props.courier.messageSuccess(
            t(
              `Se carg${numProjetct === 1 ? "o" : "aron"} ${numProjetct} fila${
                numProjetct === 1 ? "" : "s"
              } de manera exitosa`
            )
          );

          if (importForm.error) {
            props.courier.messageError(importForm.error);
          }

          setListFile([]);
        } catch (error) {
          console.log(error);
          props.courier.messageError(
            t(
              "En esta fecha ya no está disponible la creación/edición de actividades y tampoco la confirmacion de participación de las mismas"
            )
          );
        }
      }
      props.changeBlockUI(false);
    };

    const handleConfirmRecoveredDataDialog = async() => {
      props.courier.messageWarning('')
      setShowRecoveredDataDialog(false);
      props.changeBlockUI(true);

      const recoveredData = getSessionStorageDataTable() as  IAddRows[];

      if (recoveredData.length > 0) {
        const updatedRows = recoveredData.map((item: any) => {
          const newData = { ...item, id: uuidv4(), options: 0 };
          return validateRow(newData, newData.id);
        });

        setAddRows(updatedRows);
        HandlerNumError(recoveredData);
      }
      props.changeBlockUI(false);
    }

    const handleCancelHoursDialog = () => {
      setShowHoursDialog(false);
    };

    const handleCancelRecoveredDataDialog = () => {
      setShowRecoveredDataDialog(false);
    };

    const postPlantillaActividadesXColaborador = async () => {
      const filteredRows = addRows.filter((row) => row.valida === 1);
      const parceData:IPosplantillaActividadesColaborador[] = await Promise.all(filteredRows.map( async (row: IAddRows) =>{
        let ar_id:string = row.actividadRecurrenteSelect?.ar_id ||"";
            if(ar_id === ""){
              const recuperation:IAddRecurrentActivity ={
                codigoConcepto:parseInt(row.tipoConcepto.key as string) ,
                codigoProyecto:parseInt(row.nombrePro.key as string),
                nombreActividad:row.nombreAct,
                codigoEmpresa:parseInt(row.nombreEmp.code as string), 
                codigoPais:parseInt(row.paisEmpresa.code as string),
              }
              const {ar_id_data} = await props.system.postAddRecurrentActivity(recuperation,headers.idTransaccion);
              ar_id=ar_id_data;
            }
        return{
          paxc_col_id:collaboratorId,
          paxc_data:{
            ar_id:ar_id,
            proy_id:row.nombrePro.key,
            recurrent:row.actividadRecurrente,
            tc_id:row.tipoConcepto.key,
            ar_pais_id:row.paisEmpresa.key,
            ar_empresa_id:row.nombreEmp.key,
            ar_empresa_select: row.comapaniesSelect || [],
            ar_descripcion:row.descripcion,
          }
        }
      })) as any  ;

        await props.system.postPlantillaActividadesXColaborador( parceData,headers.idTransaccion);
    };

    const getHorasTal = async (col_id:string,exercise_period:string)=>{
      setDesableAddRow(true)
      const body = { col_id,  exercise_period}

      const firstDay = DateTime.fromFormat(exercise_period, 'yyyy-MM')
        .startOf('month');

      const lastDay = DateTime.fromFormat(exercise_period, 'yyyy-MM')
        .endOf('month');

      const dataHours = await props.system.getPanelSystem().getMyPlanProjectData(firstDay, lastDay, col_id);
      const statusHours = dataHours.estadoHoras[0]["horas"];
      let pending_minutes = statusHours.horasFaltantes ?  statusHours.horasFaltantes * 60 : statusHours.horasExcedidas * -60;

      if(dataHours && dataHours.estadoHoras && dataHours.estadoHoras.length > 0){
       setHorasTotal(pending_minutes);
       setHorasExcedidas(statusHours.horasExcedidas);
       setHorasTotalCollaborator(pending_minutes);
       setDesableAddRow(()=>false);
      }
    };

    const getListActivityRecurring = async(collaboratorId:string)=>{
      setLoading(true);
      const uuidTransaccion=uuidv4();
      const exercise_period = formatDate(periodo);
      const data = await props.system.getAllProjectsByCollaboratorCargarFormulario(collaboratorId,exercise_period);
      const projectsList =  data.map(v=>({ key:v.getId(),text:v.getName(), code:v.getCode() }));
      const projectValided = projectsList.map(item=>item?.key);

        if(projectValided.length !== 0){
          const activity:IPlantillaActividadesXColaborador[] = await props.system.getPlantillaActividadesXColaborador(collaboratorId,headers.idTransaccion,projectValided);

          if(activity.length === 0) {
            HandlerAddRows();
          }else{
            let options: IComboBoxOption[] = [];
                let filterDataCompany: any = [];
                const listActivity:IAddRows[] = await Promise.all (activity.map( async item =>{
                const getListActvityRecurring= await props.system.getLisActivityRecurring(String(item.paxc_data.proy_id),uuidTransaccion);
                const getListActvityRecurringFormat: IActivityRecurringGrid[] = getListActvityRecurring.map(item => {
                  const { key, text, ...rest } = item;
                  return {
                      ...rest,
                      value: key,
                      label: text,
                  };
                })
                const exercise_period = formatDate(periodo);
                const data = await fetchProjects(collaboratorId,exercise_period,item.paxc_data.tipoConcepto.tc_id);
                //const dataCompany = await fetchCompany(collaboratorId,exercise_period,item.paxc_data.tipoConcepto.tc_id);
                const listaCountryData = await props.system.getCountrySystem().getDataCountries();
                const listaCountryTranform: IComboBoxOption[] = listaCountryData.map((country) => ({
                  key: country.pais_id,
                  text: country.pais_nombre,
                }));
                const dataCountry:any = await listaCountryTranform.filter((g) => String(g.key) === String(item?.paxc_data.ar_pais_id));
                if (dataCountry.length > 0) {
                  const dataCompany = await props.system.getCompanySystem().getEmpresasByCountry(dataCountry[0]?.key);
                  if (dataCompany.data.length > 0) {
                    const companies = dataCompany.data;
                    options = companies?.map((company) => ({
                      key: company.emp_id,
                      text: company.emp_nombre,
                    }));
                  }
                  filterDataCompany = options.filter((g) => g.key === item?.paxc_data.ar_empresa_id);
                }

                const newdata: IAddRows = {
                id: uuidv4(),
                nombrePro: { key: item.paxc_data.proy_id, text:item.paxc_data.pro_nombre },
                nombreAct: item.paxc_data.ar_nombre_act,
                horasCarg: "",
                minuteCarg: "",
                file: "",
                valida: 2,
                descripcionError: t("actividades recurrentes"),
                actividadRecurrente:item.paxc_data.recurrent,
                lisActRecurrente:getListActvityRecurringFormat,
                actividadRecurrenteSelect:{...actividadRecurrentenbasic,ar_id:item.paxc_data.ar_id},
                tipoConcepto:{key:item.paxc_data.tipoConcepto.tc_id,
                              text:item.paxc_data.tipoConcepto.tc_nombre,codigo:item.paxc_data.tipoConcepto.tc_codigo},
                listaProyectos:data || [],
                listaEmpresa: [],
                filterListProyectos:data || [],
                descripcion: item.paxc_data.ar_descripcion ||"",
                paisEmpresa: dataCountry[0] ||  { key: "", text: "" },
                nombreEmp: filterDataCompany[0] || { key: "", text: "" },
                options:0,
                files: [],
                comapaniesSelect: item.paxc_data.ar_empresa_select || []
              };
                return newdata;
              }))
              setAddRows(listActivity);
          }
        }
        setLoading(false);
    }

    const handleSelectedRowsChange = (rows: IAddRows[]) => {
      setSelectedRows(rows);
    };

    const handlerDuplicateRow = () => {
      const updatedRows = selectedRows?.map((item: any) => {
        const newData = { ...item, id: uuidv4(), options: 0 };
        return validateRow(newData, newData.id);
      });

      setAddRows(prev => [...prev, ...updatedRows]);

      saveOnSessionStorageDataTable([...addRows, ...updatedRows]);
      HandlerNumError([...addRows, ...updatedRows]);
    }

    const countryFilterChange = (text: string, id: string) => {
      const updatedRows = addRows.map(r => r.id === id ? { ...r, paisEmpresa: { ...r.paisEmpresa, text: text || ""}} : r);
      validateRowById(updatedRows, id);
    };

    const companyFilterChange = (text: string, id: string) => {
      const updatedRows = addRows.map(r => r.id === id ? { ...r, nombreEmp: { ...r.nombreEmp, text: text || ""}} : r);
      validateRowById(updatedRows, id);
    };

    const onClickCallout = (id: string) => {
      const updatedRows = addRows.map(r => r.id === id ? { ...r, options: r.options === 0 ? 1 : 0 }: r);
      validateRowById(updatedRows, id);
    }

    useEffect(() => {
      if (!collaboratorId) return;
      const fetchData = async () => {
        try {
          await getListActivityRecurring(collaboratorId);
          await getCompaniesAndProjects();
          getDataLocalStorage();
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    },[periodo,collaboratorId]);

    useEffect(()=>{
      getLisTipoConcept();
      getAllPeriodBlocks();
      if(props.user){
        handleSelectCollaborator({key:props.user.getCollaboratorId(),text:props.user.getCollaborator().getName() +" "+ props.user.getCollaborator().getLastName()});
      }
      fetchCollaborators()
    },[]);

    const handleMultipleFiles = async (fileList: File[], project: IComboBoxOption, rowId: string) => {
      const idfolder: any = await getIdfolder(String(project?.key));

      const newFileEntries: IListFile[] = fileList.map((file) => ({
        path: file,
        // Agregar un id compusto para despues poder eliminarlo si eliminan las fila
        id: `${rowId}@${uuidv4()}`,
        file: {
          cmd_proid: project.key,
          cmd_cant_archivos: 1,
          cmd_cant_bytes_total: file.size,
          cmd_tipo: "proyecto",
          folderId: String(idfolder?.pca_id),
          cargaDocumentosItems: [
            {
              cmdi_cant_bytes: file.size,
              cmdi_doc_uuid: "0",
              cmdi_nombre_archivo: file.name,
              cmdi_content_type: file.type,
              doctId: '',
              tipo: "proyecto"
            }
          ]
        }
      }));

      // Agregar o reemplazar archivos para esa fila
      setListFile(prev => {
        return [...prev, ...newFileEntries]
      });

      // Guardar también en la fila
      setAddRows(prev =>
        prev.map(row =>
          row.id === rowId
            ? { ...row, files: [...(row.files || []), ...fileList] }
            : row
        )
      );
    };

    const handleFileDelete = (index: number, rowId: string) => {
      setAddRows(prev =>
        prev.map(row =>
          row.id === rowId
            ? { ...row, files: row.files.filter((_, i) => i !== index) }
            : row
        )
      );

      setListFile(prev =>
        prev.filter((item, i) => {
          const isSameRow = item.id.startsWith(rowId + '@'); // Verifica si el id comienza con rowId
          const indexInRow = prev.filter(f => f.id.startsWith(rowId + '@')).indexOf(item);
          return !isSameRow || indexInRow !== index;
        })
      );
    };

    const handleChangeNumberNewRows = (value:string|undefined) => {
      setCountAddRows(parseInt(value || "1"));
    }

    return (
      <form
        className="ms-Grid"
        dir="ltr"
        style={{
          maxHeight: "100%",
          fontFamily:
            'Segoe UI, "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
        }}
        onSubmit={onsubmit}
      >
        <FormUploadHeader />
        <Custoneader
          mountBlock={mountBlock}
          filteredCollaborators={filteredCollaborators}
          collaboratorValue={collaboratorValue}
          handleSelectCollaborator={handleSelectCollaborator}
          handleFilterCollaborator={handleFilterCollaborator}
          periodo={periodo}
          HandlerPeriodo={HandlerPeriodo}
          horasTotal={horasTotal}
          addrowlength={addRows.length}
          convertMinToHour={convertMinToHour}
          desabled={desabled}
          UploadIcon={UploadIcon}
          actError={actError}
          tipoConcept={listtipoConcept}
          desableAddRow={desableAddRow}
          HandlerDuplicateRows={handlerDuplicateRow}
          AddIcon={AddIcon}
          dataUser={props.user}
          HandlercleanEverything={HandlercleanEverything}
          courier={props.courier}
          handleChangeNumberNewRows={handleChangeNumberNewRows}
        />
        <br />
        <br />
        <MyDetailsList 
          aiActivityEnhancementSystem={props.system.getAiActivityEnhancementSystem()}
          updateActivityNameAndDescription={updateActivityNameAndDescription}
          HandlerContHoras={HandlerContHoras} 
          HandlerDeleteRows={HandlerDeleteRows}
          HandlerNombreAct={HandlerNombreAct} 
          HandlerNombreActNuevo={HandlerNombreActNuevo} 
          ProjectFilterChange={ProjectFilterChange}
          addRows={addRows} 
          companyFilterChange={companyFilterChange} 
          countryFilterChange={countryFilterChange}
          filterTipoConsept={filterTipoConsept} 
          handlerDescripcion={handlerDescripcion}
          handlerDuplicateRow={handlerDuplicateRow} 
          listCompanies={listCompanies}
          onselecTipoConcept={onselecTipoConcept}
          onselectCompany={onselectCompany} 
          onselectCountry={onselectCountry} 
          onselectProject={onselectProject} 
          tipoConceptFilterChange={tipoConceptFilterChange} 
          loading={loading} onClickCallout={onClickCallout} 
          handleMultipleFiles={handleMultipleFiles}
          handleFileDelete={handleFileDelete}
          HandlerAddRows={HandlerAddRows}
          HandlerContOnlyMinute={HandlerContOnlyMinute}
          HandlerPasteData={HandlerPasteData}
          HandlerDeleteData={HandlerDeleteData}
          HandlercleanEverything={HandlercleanEverything}
          handleSelectedRowsChange={handleSelectedRowsChange}
          countAddRows={countAddRows}
          selectedRowsMain={selectedRows}
          />

      <HoursLimitDialog
        isOpen={showHoursDialog}
        horasExcedidas={horasExcedidas}
        onConfirm={handleConfirmHoursDialog}
        onCancel={handleCancelHoursDialog}
      />

      <DialogRecoveredData
        isOpen={showRecoveredDataDialog}
        onConfirm={handleConfirmRecoveredDataDialog}
        onCancel={handleCancelRecoveredDataDialog}
      />
      </form>
    );
}
  
export default CargarPorTabla